import Vue from 'vue'
import {ButtonGroup,DatePicker,Upload,Tabs,TabPane,Pagination,Tag,Checkbox,CheckboxButton,CheckboxGroup,Dialog,Select,Option,OptionGroup,Loading,Table, TableColumn, Breadcrumb,BreadcrumbItem,Popover,Tooltip,Radio,RadioGroup,RadioButton,Button,Input,Row,Col,Form,FormItem,Icon,InputNumber,Message,MessageBox,ColorPicker ,Container, Header, Aside,Main,Footer,Menu,Submenu,MenuItem,MenuItemGroup} from 'element-ui'
Vue.use(Button);
Vue.use(ButtonGroup);
Vue.use(Select);
Vue.use(Option);
Vue.use(OptionGroup);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Row);
Vue.use(Col);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Icon); 
Vue.use(ColorPicker);
Vue.use(Container);
Vue.use(Header);
Vue.use(Aside);
Vue.use(Main);
Vue.use(Footer); 
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(MenuItemGroup);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(Tooltip);
Vue.use(Popover); 
Vue.use(Breadcrumb); 
Vue.use(BreadcrumbItem); 
Vue.use(Table); 
Vue.use(TableColumn); 
Vue.use(Loading); 
Vue.use(Dialog); 
Vue.use(Checkbox); 
Vue.use(CheckboxButton); 
Vue.use(CheckboxGroup); 
Vue.use(Tag); 
Vue.use(Pagination); 
Vue.use(Tabs); 
Vue.use(TabPane); 
Vue.use(Upload); 
Vue.use(DatePicker);
Vue.prototype.$message = Message   //放入全局 
Vue.prototype.$confirm  = MessageBox.confirm    //放入全局 


// WEBPACK FOOTER //
// ./src/public/ElementUI.js